import React, { PureComponent, Fragment } from 'react';

import { PropTypes as MobxPropTypes } from 'mobx-react';

import { MAX_USER_NAME_DISPLAY } from '../../constants';

export default class NotificationItemNames extends PureComponent {
  static propTypes = {
    names: MobxPropTypes.observableArray
  };

  renderNames(user, index) {
    return (
      <Fragment key={user}>
        {index !== 0 && ','}
        <b>{user}</b>
      </Fragment>
    );
  }

  render() {
    const { names } = this.props;

    const users = names.slice(0, MAX_USER_NAME_DISPLAY).map(this.renderNames);

    return <b>{users}</b>;
  }
}
